import "./widget.scss";
import { useNavigate } from "react-router-dom";

const Widget = ({ type, countValue, linkRoute }) => {
  const navigate = useNavigate();
  let data;

  switch (type) {
    case "user":
      data = {
        title: "USERS",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "See all Users",
      };
      break;
    case "news":
      data = {
        title: "NEWS",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "See all News",
      };
      break;
    case "ghar":
      data = {
        title: "HOME STAY",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "See all Homestay",
      };
      break;
    case "product":
      data = {
        title: "PRODUCTS",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "View all products",
      };
      break;
    case "trecking":
      data = {
        title: "TRECKING",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "View all Trecking",
      };
      break;
    case "videos":
      data = {
        title: "VIDEOS",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "View all Videos",
      };
      break;
    case "events":
      data = {
        title: "Events",
        countValue: countValue,
        linkRoute: linkRoute,
        link: "See all Events",
      };
      break;
    case "people":
      data = {
        title: "Population",
        countValue: countValue,
        // linkRoute: linkRoute,
        // link: "See all People",
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.isMoney && "$"} {data.countValue}
        </span>
        <span className="link" onClick={() => navigate(data.linkRoute)}>
          {data.link}
        </span>
      </div>
      {/* <div className="right">
        <div className="percentage positive">
          <KeyboardArrowUpIcon />
          {diff}%
        </div>
        {data.icon}
      </div> */}
    </div>
  );
};

export default Widget;
